import { z } from "zod";
import { userResponseSchema } from "@common/schemas/user.schema";
import { ConnectionProvider } from "@common/types/integrationConnection";
import { utcDatetime } from "@common/helpers/date";
import { jsonValueSchema } from "@common/schemas/json.schema";
import {
    financialAccountSchema,
    integrationAccountResponseSchema,
} from "@common/schemas/financialAccount.schema";
import { subaccountSchema } from "@common/schemas/subaccount.schema";
import { entityWithUnloadedRelationsResponseSchema } from "@common/schemas/domains/entity/entity-response.schema";
import { financialConnectionResponseSchema } from "@common/schemas/domains/financialAccount/financial-connection-response.schema";

export const integrationConnectionResponseSchema = z.object({
    id: z.string(),
    provider: z.nativeEnum(ConnectionProvider),
    providerId: z.string().nullable(),
    label: z.string().nullable(),
    workspaceId: z.string().nullable(),
    entityId: z.number().nullable(),
    createdByUserId: z.number().nullable(),
    createdByUser: userResponseSchema.nullable().default(null),
    createdAt: utcDatetime,
    institutionLogoUrl: z.string().nullable(),
    institutionName: z.string().nullable(),
    metadata: jsonValueSchema,
    error: z.string().nullable(),
    counterpartiesSyncedAt: utcDatetime.nullable(),
    classesSyncedAt: utcDatetime.nullable(),
});

const integrationConnectionFinancialAccountResponseSchema =
    financialAccountSchema.extend({
        order: z.number(),
        entity: entityWithUnloadedRelationsResponseSchema
            .nullable()
            .default(null),
        subaccounts: z.array(subaccountSchema).default([]),
    });

const integrationConnectionAccountResponseSchema =
    integrationAccountResponseSchema.extend({
        connection: financialConnectionResponseSchema.nullable().default(null),
        financialAccount: integrationConnectionFinancialAccountResponseSchema
            .nullable()
            .default(null),
    });

export const integrationConnectionWithAccountsResponseSchema =
    integrationConnectionResponseSchema.extend({
        integrationAccounts: z
            .array(integrationConnectionAccountResponseSchema)
            .optional(),
    });

export type IntegrationConnectionWithAccountsResponse = z.output<
    typeof integrationConnectionWithAccountsResponseSchema
>;
